import { render, staticRenderFns } from "./FaturaIslemleri.vue?vue&type=template&id=651991cc&"
import script from "./FaturaIslemleri.vue?vue&type=script&lang=js&"
export * from "./FaturaIslemleri.vue?vue&type=script&lang=js&"
import style0 from "./FaturaIslemleri.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports